import { useEffect } from 'react';

// `undefined` leaves the title alone (for a page embedded inside another page).
export default function usePageTitle(title) {
  useEffect(() => {
    if (title === undefined) return;
    document.title = title ? `${title} | My Inventory` : 'My Inventory';
  }, [title]);
}
